export default class RelatedController {
  /* @ngInject */
  constructor(RelatedModel) {
    this.RelatedModel = RelatedModel;
  }

  $onChanges(changes) {
    if (changes.relatedList && changes.relatedList.currentValue) {
      const newRelatedList = changes.relatedList.currentValue.map(i => new this.RelatedModel(i));
      const newRelatedOrdered = [...newRelatedList.filter(i => i.image.url), ...newRelatedList.filter(i => !i.image.url)];
      this.newRelatedList = newRelatedOrdered.slice(0, +this.takeOnly || 4);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/related/related.controller.js